import { Bookend } from "./Bookend";

export const UniversalRender = Bookend;
